import angular from 'angular';
import SendReportsToEsign from './sendReportsToEsign';

export default angular
  .module('components.sendReportsToEsign', [])
  .component('sendReportsToEsign', SendReportsToEsign).name;
